﻿import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ResponseAPI } from 'src/app/models/response.model';

@Injectable()
export class AuthenticationService {
    
    imagen: string;
    public token: string;
    baseUrl = environment.apiEndpoint;
    private auUrl = environment.auEndpoint;
    constructor(private http: HttpClient, private router: Router) {
    }

    private header(accessToken: string) {
        var headers = new HttpHeaders({
            'Content-Type': 'application/json',
            "Accept": "application/json",
            "Authorization": "Bearer " + accessToken
        });
        return headers;
    }

    postLogin(data: any): Observable<any> {        
        return this.http.post<ResponseAPI>(this.baseUrl + 'jwtlogin', JSON.stringify(data), { headers: this.header(this.token) })
        .pipe(
            map( res =>{                              
                return res;
              }),
              catchError( err => of(false) )
        );
    }

    getToken() {
        let user = JSON.parse(localStorage.getItem('u'));
        if (user == null) return null;
        else return user.token;
    }


    login(username: string, password: string) {
        return this.http.post<any>(this.baseUrl + 'jwtlogin', { email: username, password: password })
            .pipe(map(user => {
               
                if (user) {
                    
                    localStorage.setItem('u', JSON.stringify(user));
                }
                return user;
            }));
    }

    logout() {
        this.token = '';
        localStorage.removeItem('u');
        localStorage.removeItem('g');
        localStorage.removeItem('menu');
        localStorage.removeItem('v');
        localStorage.clear();
        this.router.navigate(['/login']);
    }

    getDataUser(usuario: string, sistema: string): Observable<any> {
        return this.http.post(this.auUrl + 'solicitud/acceso', { "usuario_id": usuario, "sistema_id": sistema }, { headers: this.header(this.token) });
    }

    reenviarPassword(data: any): Observable<any> {        
        return this.http.post(this.baseUrl + 'resetPassword', JSON.stringify(data), { headers: this.header(this.token) });
    }

}